<div class="qrcode-section">
  <div class="container">
    <ngx-qrcode
      [value] = "value"
      cssClass = "aclass">
</ngx-qrcode>
  </div>
</div>
